import i18n from 'i18next';
import { put, call, takeLatest, all, select } from 'redux-saga/effects';
import { processRequest } from '../../services/Api';
import { historyReplace } from '../../services/History';
import { folderDetailsActionTypes } from './Constants';
import { getUserName } from './Selectors';
import * as folderDetailsActions from './Actions';
import * as notificationActions from '../../components/notification/Actions';
import * as createFolderActions from '../../components/modals/createFolder/Actions';
import * as sidebarActions from '../../components/sideBar/Actions';
import * as listsActions from '../lists/Actions';
import * as publicProfileActions from '../publicProfile/Actions';
import * as errorHandlerActions from '../../components/errorHandler/Actions';

export default function* () {
	yield all([
		yield takeLatest(
			folderDetailsActionTypes.GET_FOLDER_DETAILS_REQUEST,
			handleFolderDetailsRequest,
		),
		yield takeLatest(folderDetailsActionTypes.UPDATE_FOLDER_REQUEST, handleUpdateFolderRequest),
		yield takeLatest(folderDetailsActionTypes.DELETE_FOLDER_REQUEST, handleDeleteFolderRequest),
		yield takeLatest(folderDetailsActionTypes.FOLDER_ADD_ITEMS_REQUEST, handleAddItemsRequest),
		yield takeLatest(
			folderDetailsActionTypes.DELETE_LIST_FROM_FOLDER_REQUEST,
			handleDeleteListFromFolderRequest,
		),
	]);
}

export function* handleFolderDetailsRequest(action) {
	try {
		const { id } = action.payload;

		const { data } = yield call(processRequest, `folders/${id}`);

		yield put(folderDetailsActions.getFolderDetailsSuccess(data.folder));
	} catch (e) {
		if (e.response.status === 403) {
			yield put(folderDetailsActions.getFolderDetailsSuccess({}));
		}
		yield put(errorHandlerActions.handleError(e));
		yield put(folderDetailsActions.getFolderDetailsError(e));
	}
}

export function* handleDeleteListFromFolderRequest({ payload }) {
	try {
		const { id, itemId, isUserQuiz } = payload.data;
		const requestPayload = {
			practiceable_item: {
				type: isUserQuiz ? 'user_quiz' : 'list',
				id: itemId,
			},
		};

		yield call(
			processRequest,
			`folders/${id}/remove_practiceable_item`,
			'POST',
			requestPayload,
		);
		yield put(
			notificationActions.createNotification(
				i18n.t('folder_details.delete_list_from_map')
			),
		);
		yield put(folderDetailsActions.getFolderDetailsRequest(id));
	} catch (e) {
		yield put(errorHandlerActions.handleError(e, 'notification'));
		yield put(folderDetailsActions.deleteListFromFolderError(e));
	}
}

export function* handleAddItemsRequest(action) {
	try {
		const { id, practiceableItems } = action.payload;

		const { data } = yield call(
			processRequest,
			`folders/${id}/add_practiceable_items`,
			'POST',
			{
				practiceable_items: practiceableItems,
			},
		);

		yield put(folderDetailsActions.addItemsSuccess());
		yield put(folderDetailsActions.getFolderDetailsSuccess(data.folder));
		yield put(
			notificationActions.createNotification(
				i18n.t('folder_details.add_exercise_to_folder', {
					count: practiceableItems.length,
				})
			),
		);
	} catch (e) {
		yield put(errorHandlerActions.handleError(e, 'notification'));
		yield put(folderDetailsActions.addItemsError());
	}
}

export function* handleUpdateFolderRequest(action) {
	try {
		const { folderId, options, openFrom, showNotification } = action.payload;
		const username = yield select(getUserName);
		const requestPayload = {
			folder: {
				...options,
			},
		};

		const { data } = yield call(processRequest, `folders/${folderId}`, 'PATCH', requestPayload);

		if (openFrom === 'profile') {
			yield put(publicProfileActions.getPublicFoldersRequest(username));
		} else {
			yield put(listsActions.getFoldersRequest());
		}
		yield put(sidebarActions.getUseDataRequest());
		yield put(createFolderActions.toggleCreateFolderModal(false));
		yield put(folderDetailsActions.updateFolderSuccess(data.folder));
		if (showNotification)
			yield put(
				notificationActions.createNotification(
					i18n.t('general.saved_changes')
				),
			);
	} catch (e) {
		yield put(errorHandlerActions.handleError(e, 'notification'));
		yield put(folderDetailsActions.updateFolderError());
	}
}

export function* handleDeleteFolderRequest(action) {
	try {
		const { folderId } = action.payload;

		yield call(processRequest, `folders/${folderId}`, 'DELETE');
		yield put(sidebarActions.getUseDataRequest());
		yield put(listsActions.getFoldersRequest());
		yield call(historyReplace, '/folders');
	} catch (e) {
		yield put(errorHandlerActions.handleError(e, 'notification'));
		yield put(folderDetailsActions.deleteFolderError());
	}
}
